module.exports = __webpack_public_path__ + "img/gb_summary_Image.e2c6769c.png";